import {
  includeRule,
  excludeRule,
  hideOptionSet
}
from './rules_functions.js';

  
  
export function rules_rsetl(newState, state) {
  //rules with 4 conditions:
  var newrule = includeRule(newState, state, 'rsetl')
  var show  = hideOptionSet(newState, state, [ ['rset', ['0']]])
  newrule['show']  = show
    return newrule
}


